/*
 *
 * MeasurementHistory reducer
 *
 */

import { fromJS } from "immutable"
import {
  LIST_SURVEYS_WATCHER,
  LIST_SURVEYS_SUCCESS,
  LIST_SURVEYS_FAILED,
  LIST_MEASUREMENTS_WATCHER,
  LIST_MEASUREMENTS_SUCCESS,
  LIST_MEASUREMENTS_FAILED,
  DELETE_MEASURE_WATCHER,
  HAS_COLLABORATORS_WATCHER,
  HAS_COLLABORATORS_SUCCESS,
  HAS_COLLABORATORS_FAILED,
} from "./constants"

export const initialState = fromJS({
  listSurveys: [],
  isLoadingListSurveys: undefined,
  listMeasurements: [],
  isLoadingListMeasurements: undefined,
  hasCollaborators: undefined,
  isLoadingHasCollaborators: true,
})

function measurementHistoryReducer(state = initialState, action) {
  switch (action.type) {
    case HAS_COLLABORATORS_WATCHER:
      return state
        .set("isLoadingHasCollaborators", true)
        .set("hasCollaborators", undefined)
    case HAS_COLLABORATORS_SUCCESS:
      return state
        .set("isLoadingHasCollaborators", false)
        .set("hasCollaborators", action.payload)
    case HAS_COLLABORATORS_FAILED:
      return state
        .set("isLoadingHasCollaborators", false)
        .set("hasCollaborators", undefined)

    case LIST_MEASUREMENTS_WATCHER:
    case DELETE_MEASURE_WATCHER:
      return state.set("isLoadingListMeasurements", undefined)
    // .set('listMeasurements', [])
    case LIST_MEASUREMENTS_SUCCESS:
      return state
        .set("isLoadingListMeasurements", true)
        .set("listMeasurements", action.payload)
    case LIST_MEASUREMENTS_FAILED:
      return state
        .set("isLoadingListMeasurements", false)
        .set("listMeasurements", [])

    case LIST_SURVEYS_WATCHER:
      return state.set("isLoadingListSurveys", undefined).set("listSurveys", [])
    case LIST_SURVEYS_SUCCESS:
      return state
        .set("isLoadingListSurveys", true)
        .set("listSurveys", action.payload)
    case LIST_SURVEYS_FAILED:
      return state.set("isLoadingListSurveys", false).set("listSurveys", [])

    default:
      return state
  }
}

export default measurementHistoryReducer
